(function () {
  'use strict';

  var root = document.querySelector('[data-csd]');
  if (
    !root ||
    typeof window.Konva === 'undefined' ||
    typeof window.THREE === 'undefined' ||
    !window.ERSChopstickSleeveGeometry
  ) return;
  if (root.getAttribute('data-csd-initialized') === 'true') return;
  root.setAttribute('data-csd-initialized', 'true');

  Konva.hitOnDragEnabled = true;
  Konva.dragDistance = 2;

  var WIDTH = 1050;
  var HEIGHT = 100;
  var RENDER_SCALE = 2;
  var PRINT_AREA = { x: 34, y: 18, width: WIDTH - 68, height: HEIGHT - 36 };
  var STORAGE_KEY = 'ers-chopstick-sleeve-design-v2';
  var stage;
  var artLayer;
  var transformer;
  var activeSide = 'front';
  var selectedId = null;
  var imageCache = {};
  var pendingUploads = 0;
  var uploadError = '';
  var history = [];
  var historyIndex = -1;
  var historyLocked = false;
  var viewer;
  var renderTimer;
  var hoveredSampleKey = null;
  var MOBILE_GUIDANCE_KEY = 'ers-csd-mobile-guidance-dismissed';

  var canvasHost = root.querySelector('[data-csd-canvas]');
  var editorPanel = root.querySelector('.csd__editor-panel');
  var mobileGuidance = root.querySelector('[data-csd-mobile-guidance]');
  var mobileGuidanceDismiss = root.querySelector('[data-csd-mobile-guidance-dismiss]');
  var selectionPanel = root.querySelector('[data-csd-selection]');
  var textControlGroups = root.querySelectorAll('[data-csd-text-controls]');
  var textValue = root.querySelector('[data-csd-text-value]');
  var fontSelect = root.querySelector('[data-csd-font]');
  var colorInput = root.querySelector('[data-csd-color]');
  var fontSizeInput = root.querySelector('[data-csd-font-size]');
  var letterSpacingInput = root.querySelector('[data-csd-letter-spacing]');
  var boldButton = root.querySelector('[data-csd-bold]');
  var italicButton = root.querySelector('[data-csd-italic]');
  var printColorInput = root.querySelector('[data-csd-print-color]');
  var colorWarning = root.querySelector('[data-csd-color-warning]');
  var logoInput = root.querySelector('[data-csd-logo-input]');
  var logoLabel = root.querySelector('[data-csd-logo-label]');
  var objectList = root.querySelector('[data-csd-object-list]');
  var undoButton = root.querySelector('[data-csd-undo]');
  var redoButton = root.querySelector('[data-csd-redo]');
  var saveState = root.querySelector('[data-csd-save-state]');
  var orderForm = root.querySelector('.csd__order-form');
  var orderArtworkInput = root.querySelector('[data-csd-order-artwork]');
  var orderLogoName = root.querySelector('[data-csd-order-logo-name]');
  var orderPreview = root.querySelector('[data-csd-order-preview]');
  var quantityInput = root.querySelector('[data-csd-quantity]');
  var notesInput = root.querySelector('[data-csd-notes]');
  var orderError = root.querySelector('[data-csd-order-error]');
  var orderLogoFile = null;
  var proofCanvases = {
    front: root.querySelector('[data-csd-proof="front"]'),
    back: root.querySelector('[data-csd-proof="back"]')
  };
  var viewerCanvases = {
    front: document.createElement('canvas'),
    back: document.createElement('canvas')
  };
  viewerCanvases.front.width = viewerCanvases.back.width = WIDTH * RENDER_SCALE;
  viewerCanvases.front.height = viewerCanvases.back.height = HEIGHT * RENDER_SCALE;
  proofCanvases.front.width = proofCanvases.back.width = WIDTH * RENDER_SCALE;
  proofCanvases.front.height = proofCanvases.back.height = HEIGHT * RENDER_SCALE;

  function id(prefix) {
    return prefix + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
  }

  function designReference() {
    return window.ErsProofStorage.createReference();
  }

  function textObject(text, x, y, width, size, font, color, options) {
    options = options || {};
    return {
      id: id('text'),
      type: 'text',
      role: options.role || '',
      text: text,
      x: x,
      y: y,
      width: width,
      fontSize: size,
      fontFamily: font,
      fontStyle: options.fontStyle || 'normal',
      letterSpacing: options.letterSpacing || 0,
      fill: color,
      align: options.align || 'center',
      rotation: options.rotation || 0
    };
  }

  function contactObjects(color, font, compact) {
    if (compact) {
      return [
        textObject('1000 E Olympic Blvd, Los Angeles, CA 90021', .5, .34, .78, .13, font, color),
        textObject('Tel: 213-620-1400  •  info@edenrs.com', .5, .66, .68, .12, font, color)
      ];
    }
    return [
      textObject('1000 E Olympic Blvd, Los Angeles, CA 90021', .31, .43, .49, .12, font, color),
      textObject('Tel: 213-620-1400', .72, .36, .30, .115, font, color),
      textObject('info@edenrs.com', .72, .65, .30, .105, font, color)
    ];
  }

  function vectorObject(sampleKey, crop, x, y, width, height, options) {
    options = options || {};
    return {
      id: id('vector'),
      type: 'image',
      pdfSample: sampleKey,
      crop: crop,
      x: x,
      y: y,
      width: width,
      height: height,
      rotation: options.rotation || 0,
      originalName: options.name || sampleKey + ' PDF artwork'
    };
  }

  var samples = {
    'eden': {
      name: 'Eden',
      front: {
        background: '#ffffff',
        objects: [
          textObject('EDEN', .5, .40, .3, .28, 'Georgia', '#df4d35', { fontStyle: 'bold' }),
          textObject('Restaurant Supply', .5, .67, .3, .105, 'Georgia', '#232323')
        ]
      },
      back: { background: '#ffffff', objects: contactObjects('#232323', 'Arial', false) }
    },
    'luxury-sushi': {
      name: 'Classic',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('luxury-sushi', [102, 247, 128, 54], .16, .47, .17, .5, { name: 'Sushi Planet logo' }),
          textObject('(805) 523-2954', .52, .48, .28, .16, 'Courier New', '#202020', { letterSpacing: .018 }),
          vectorObject('luxury-sushi', [636, 250, 119, 47], .84, .47, .15, .48, { name: 'Social contact artwork' })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('www.sushiplanetmoorpark.com', .17, .22, .27, .09, 'Arial', '#202020', { rotation: 180 }),
          textObject('(805) 523-2954', .17, .41, .19, .09, 'Georgia', '#202020', { rotation: 180 }),
          textObject('Suite # A', .17, .57, .13, .085, 'Georgia', '#202020', { rotation: 180 }),
          textObject('537 New Los Angeles Ave.,', .17, .74, .25, .09, 'Georgia', '#202020', { rotation: 180 }),
          vectorObject('luxury-sushi', [289, 328, 263, 2], .52, .22, .35, .02, { name: 'Upper order line' }),
          textObject('ORDER ONLINE', .52, .38, .3, .1, 'Arial', '#202020'),
          textObject('http://www.sushiplanetmoorpark.com', .52, .61, .38, .1, 'Arial', '#202020', { fontStyle: 'bold' }),
          vectorObject('luxury-sushi', [289, 367, 263, 2], .52, .76, .35, .02, { name: 'Lower order line' }),
          vectorObject('luxury-sushi', [622, 329, 126, 51], .87, .5, .125, .5, { name: 'Reverse Sushi Planet logo' })
        ]
      }
    },
    'korean-bbq': {
      name: 'Bold',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('korean-bbq', [90, 255, 8, 30], .5, .5, .9, .58, { name: 'Anomalia print field' }),
          textObject('ANOMALIA', .23, .5, .36, .4, 'Georgia', '#e7e9a8'),
          textObject('EATANOMALIA.COM', .83, .5, .2, .1, 'Arial', '#e7e9a8', { letterSpacing: .008 })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          vectorObject('korean-bbq', [83, 321, 675, 54], .5, .5, .84, .54, { name: 'Anomalia pattern' })
        ]
      }
    },
    'modern-ramen': {
      name: 'Modern',
      front: {
        background: '#ffffff',
        objects: [
          textObject('MOKU', .5, .40, .28, .36, 'Times New Roman', '#202020'),
          textObject('PACIFIC PALISADES', .5, .69, .28, .11, 'Arial', '#202020', { fontStyle: 'bold', letterSpacing: .008 })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('TAKEOUTS • RESERVATIONS • PARTY PLATTER', .27, .36, .44, .12, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('(424) 272 9339 | (424) 272 9329', .23, .66, .36, .12, 'Arial', '#202020'),
          textObject('DELIVERIES\nMENU', .77, .5, .15, .12, 'Arial', '#202020', { fontStyle: 'bold' }),
          vectorObject('modern-ramen', [674, 323, 70, 52], .88, .5, .07, .5, { name: 'Menu QR code' })
        ]
      }
    },
    'traditional-izakaya': {
      name: 'Traditional',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('traditional-izakaya', [86, 248, 157, 57], .17, .5, .2, .56, { name: 'Unbelieva Bowl logo' }),
          textObject('972.807.2829', .82, .27, .18, .12, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('2160 N Coit Rd #130, Richardson, TX 75080', .8, .53, .31, .085, 'Arial', '#202020'),
          textObject('UnbelievaBowlAsianGrill.com', .8, .72, .27, .08, 'Arial', '#202020'),
          vectorObject('traditional-izakaya', [638, 287, 111, 15], .82, .83, .14, .15, { name: 'Social media icons' })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('UnbelievaBowlAsianGrill.com', .18, .2, .28, .08, 'Arial', '#202020', { rotation: 180 }),
          textObject('2160 N Coit Rd #130, Richardson, TX 75080', .18, .42, .31, .085, 'Arial', '#202020', { rotation: 180 }),
          textObject('972.807.2829', .18, .72, .18, .12, 'Arial', '#202020', { fontStyle: 'bold', rotation: 180 }),
          vectorObject('traditional-izakaya', [83, 322, 115, 15], .18, .14, .14, .15, { name: 'Reverse social media icons' }),
          vectorObject('traditional-izakaya', [600, 326, 160, 54], .82, .5, .2, .53, { name: 'Reverse Unbelieva Bowl logo' })
        ]
      }
    },
    'cafe': {
      name: 'Simple',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('cafe', [280, 258, 283, 31], .5, .5, .36, .32, { name: 'Masa signature logo' })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('@masasushila', .5, .5, .36, .24, 'Arial', '#202020', { fontStyle: 'bold' })
        ]
      }
    },
    'text-only': {
      name: 'Text',
      front: {
        background: '#ffffff',
        objects: [
          textObject('BAMBOO 4IRPORT', .19, .28, .22, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('2601 SPRINGER BOULEVARD\nLITTLE ROCK AR 72206', .19, .64, .25, .1, 'Arial', '#202020', { fontStyle: 'bold' }),
          vectorObject('text-only', [318, 244, 206, 62], .5, .5, .26, .6, { name: 'Bamboo Hibachi logo' }),
          textObject('BAMBOO 5HERWOOD', .81, .28, .24, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('117 COUNTRY CLUB ROAD STE A\nSHERWOOD AR 72120\n501 - 864 - 4906', .81, .65, .26, .095, 'Arial', '#202020', { fontStyle: 'bold' })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          vectorObject('text-only', [310, 318, 2, 58], .34, .5, .004, .58, { name: 'Column divider 1' }),
          vectorObject('text-only', [551, 318, 2, 58], .66, .5, .004, .58, { name: 'Column divider 2' }),
          textObject('BAMBOO 1', .18, .27, .22, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('13420 OTTER CREEK PKWY STE 2\nLITTLE ROCK AR 72211\n501 - 615 - 8500', .18, .65, .27, .095, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('BAMBOO 2', .5, .27, .2, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('4511 CAMP ROBINSON ROAD\nNORTH LITTLE ROCK AR 72218\n501 - 916 - 9034', .5, .65, .27, .095, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('BAMBOO 3', .82, .27, .2, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('6606 COLONEL GLENN ROAD\nLITTLE ROCK AR 72204\n501 - 406 - 7950', .82, .65, .27, .095, 'Arial', '#202020', { fontStyle: 'bold' })
        ]
      }
    },
    'instructional': {
      name: 'Instructional',
      front: {
        background: '#5b5959',
        objects: [
          vectorObject('instructional', [68, 252, 705, 2], .5, .26, .94, .02, { name: 'Upper accent rule' }),
          vectorObject('instructional', [68, 277, 705, 2], .5, .63, .94, .02, { name: 'Lower accent rule' }),
          vectorObject('instructional', [230, 243, 52, 49], .26, .5, .07, .5, { name: 'Bulta mark' }),
          vectorObject('instructional', [283, 249, 260, 33], .52, .5, .35, .34, { name: 'Bulta K-BBQ wordmark' }),
          vectorObject('instructional', [565, 243, 44, 51], .72, .5, .06, .52, { name: 'Online order QR code' })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          vectorObject('instructional', [143, 319, 58, 57], .13, .53, .075, .57, { name: 'Choose instruction icon' }),
          textObject('1. Choose', .24, .28, .14, .12, 'Arial', '#202020', { fontStyle: 'bold', align: 'left' }),
          textObject('from our wide selection.\nTell your server your\nchoice of marinade', .24, .64, .16, .085, 'Arial', '#202020', { align: 'left' }),
          vectorObject('instructional', [294, 319, 51, 57], .35, .53, .07, .57, { name: 'Grill instruction icon' }),
          textObject('2. Grill', .45, .28, .13, .12, 'Arial', '#202020', { fontStyle: 'bold', align: 'left' }),
          textObject('30 to 60 sec. for sliced beef,\n3 to 4 min. for seafood in foil,\n2 to 3 min. for other items.', .45, .64, .19, .078, 'Arial', '#202020', { align: 'left' }),
          vectorObject('instructional', [458, 319, 51, 57], .57, .53, .07, .57, { name: 'Dip instruction icon' }),
          textObject('3. Dip', .66, .28, .12, .12, 'Arial', '#202020', { fontStyle: 'bold', align: 'left' }),
          textObject('your grilled BBQ\nitems into your\ndelicious sauce.', .66, .64, .13, .085, 'Arial', '#202020', { align: 'left' }),
          vectorObject('instructional', [588, 319, 51, 57], .75, .53, .07, .57, { name: 'Love instruction icon' }),
          textObject('4. Love', .84, .28, .12, .12, 'Arial', '#202020', { fontStyle: 'bold', align: 'left' }),
          textObject('Yum! Enjoy freshly\ngrilled BBQ right\noff the grill.', .84, .64, .13, .085, 'Arial', '#202020', { align: 'left' })
        ]
      }
    },
    'locational': {
      name: 'Locational',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('locational', [361, 243, 124, 63], .5, .5, .18, .61, { name: 'Daeho logo' })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('415 563 1388', .16, .28, .2, .13, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('1620 Post st.\nSan Francisco, CA 94115', .16, .66, .23, .105, 'Arial', '#202020'),
          textObject('408 770 3778', .39, .28, .2, .13, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('217 W Calaveras Blvd.\nMilpitas, CA 95035', .39, .66, .23, .105, 'Arial', '#202020'),
          textObject('650 389 6689', .62, .28, .2, .13, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('213 2nd Ave.\nSan Mateo, CA 94401', .62, .66, .22, .105, 'Arial', '#202020'),
          textObject('628 895 0505', .85, .24, .2, .13, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('Inside H-Mart\n3995 Alemany Blvd\nSan Francisco, CA 94132', .85, .65, .23, .092, 'Arial', '#202020')
        ]
      }
    }
  };

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function initialDesign(sampleKey) {
    var sample = samples[sampleKey];
    if (!sample) {
      sample = {
        front: { background: '#ffffff', objects: [] },
        back: { background: '#ffffff', objects: [] }
      };
    }
    return {
      schemaVersion: 1,
      designReference: designReference(),
      productId: root.getAttribute('data-product-id'),
      variantId: root.getAttribute('data-variant-id'),
      selectedSample: sampleKey || '',
      updatedAt: new Date().toISOString(),
      sides: {
        front: clone(sample.front),
        back: clone(sample.back)
      }
    };
  }

  // Ordinary visits always start with Eden. The submission adapter separately
  // recovers an in-flight attempt from its durable retry cache when needed.
  var design = initialDesign('eden');

  function activeState() {
    return design.sides[activeSide];
  }

  function objectById(objectId) {
    var objects = activeState().objects;
    for (var i = 0; i < objects.length; i++) {
      if (objects[i].id === objectId) return objects[i];
    }
    return null;
  }

  function loadImage(source, cacheKey, callback) {
    if (imageCache[cacheKey] && (imageCache[cacheKey].complete || imageCache[cacheKey].getContext)) {
      callback(imageCache[cacheKey]);
      return;
    }
    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      imageCache[cacheKey] = image;
      callback(image);
      scheduleRender();
    };
    image.src = source;
  }

  function loadArtworkImage(item, callback) {
    if (imageCache[item.id] && (imageCache[item.id].complete || imageCache[item.id].getContext)) {
      callback(imageCache[item.id]);
      return;
    }
    var assetUrl = item.assetUrl;
    if (!assetUrl && item.pdfSample) {
      var sampleButton = root.querySelector('[data-csd-sample="' + item.pdfSample + '"]');
      if (sampleButton) assetUrl = sampleButton.getAttribute('data-csd-vector-source');
    }
    if (!assetUrl) {
      loadImage(item.dataUrl, item.id, callback);
      return;
    }
    loadImage(assetUrl, 'asset-' + assetUrl, function (source) {
      var crop = item.crop || [0, 0, source.naturalWidth || source.width, source.naturalHeight || source.height];
      if (item.pdfSample) {
        var sourceWidth = source.naturalWidth || source.width;
        var sourceHeight = source.naturalHeight || source.height;
        crop = [
          crop[0] * sourceWidth / 841.89,
          crop[1] * sourceHeight / 595.275,
          crop[2] * sourceWidth / 841.89,
          crop[3] * sourceHeight / 595.275
        ];
      }
      var cropScale = item.pdfSample ? RENDER_SCALE : 1;
      var cropped = document.createElement('canvas');
      cropped.width = Math.max(1, Math.round(crop[2] * cropScale));
      cropped.height = Math.max(1, Math.round(crop[3] * cropScale));
      cropped.getContext('2d').drawImage(source, crop[0], crop[1], crop[2], crop[3], 0, 0, cropped.width, cropped.height);
      imageCache[item.id] = cropped;
      callback(cropped);
      scheduleRender();
    });
  }

  function nodeFromState(item) {
    var node;
    if (item.type === 'text') {
      node = new Konva.Text({
        x: item.x * WIDTH,
        y: item.y * HEIGHT,
        width: item.width * WIDTH,
        text: item.text,
        fill: item.fill,
        fontFamily: item.fontFamily,
        fontStyle: item.fontStyle || 'normal',
        fontSize: item.fontSize * HEIGHT,
        letterSpacing: (item.letterSpacing || 0) * HEIGHT,
        align: item.align || 'center',
        verticalAlign: 'middle',
        wrap: 'none',
        rotation: item.rotation || 0,
        draggable: true
      });
      fitTextNode(node, item.width * WIDTH);
      item.width = node.width() / WIDTH;
      node.offsetX(node.width() / 2);
      node.offsetY(node.height() / 2);
      bindNode(node, item);
      return node;
    }

    if (item.type === 'image' && (item.dataUrl || item.assetUrl || item.pdfSample)) {
      if (imageCache[item.id] && (imageCache[item.id].complete || imageCache[item.id].getContext)) {
        node = imageNode(item, imageCache[item.id]);
        bindNode(node, item);
        return node;
      }
      var targetLayer = artLayer;
      loadArtworkImage(item, function (image) {
        if (!targetLayer || artLayer !== targetLayer || targetLayer.findOne('#' + item.id)) return;
        node = imageNode(item, image);
        bindNode(node, item);
        targetLayer.add(node);
        if (selectedId === item.id) selectNode(node);
        targetLayer.draw();
      });
    }
    return null;
  }

  function imageNode(item, image) {
    return new Konva.Image({
      id: item.id,
      x: item.x * WIDTH,
      y: item.y * HEIGHT,
      width: item.width * WIDTH,
      height: item.height * HEIGHT,
      offsetX: item.width * WIDTH / 2,
      offsetY: item.height * HEIGHT / 2,
      image: image,
      rotation: item.rotation || 0,
      draggable: true,
      listening: true
    });
  }

  function fitTextNode(node, maximumWidth) {
    var availableWidth = Math.max(4, 2 * Math.min(
      node.x() - PRINT_AREA.x,
      PRINT_AREA.x + PRINT_AREA.width - node.x()
    ));
    var lines = String(node.text() || ' ').split('\n');
    var width = 0;
    for (var i = 0; i < lines.length; i++) {
      width = Math.max(
        width,
        node.measureSize(lines[i] || ' ').width + node.letterSpacing() * lines[i].length
      );
    }
    width = Math.ceil(width + 1);
    node.width(Math.max(4, Math.min(maximumWidth || availableWidth, availableWidth, width)));
    node.offsetX(node.width() / 2);
    node.offsetY(node.height() / 2);
  }

  function bindNode(node, item) {
    node.id(item.id);
    node.setAttr('csdType', item.type);
    node.hitFunc(function (context, shape) {
      context.beginPath();
      context.rect(0, 0, node.width(), node.height());
      context.closePath();
      context.fillStrokeShape(shape);
    });
    node.on('mouseenter', function () {
      stage.container().style.cursor = 'move';
    });
    node.on('mouseleave', function () {
      stage.container().style.cursor = 'default';
    });
    node.on('click tap', function (event) {
      event.cancelBubble = true;
      selectNode(node);
    });
    if (item.type === 'text') {
      node.on('dblclick dbltap', function (event) {
        event.cancelBubble = true;
        startInlineTextEdit(node);
      });
    }
    node.on('dragmove', function () {
      var zones = [.2 * WIDTH, .5 * WIDTH, .8 * WIDTH];
      for (var i = 0; i < zones.length; i++) {
        if (Math.abs(node.x() - zones[i]) < 10) {
          node.x(zones[i]);
          break;
        }
      }
      keepNodeInPrintArea(node);
      updateStateFromNode(node);
      scheduleRender();
    });
    node.on('dragend', function () {
      keepNodeInPrintArea(node);
      updateStateFromNode(node);
      commit();
    });
    node.on('transformend', function () {
      normalizeTransformedNode(node);
      keepNodeInPrintArea(node);
      updateStateFromNode(node);
      commit();
    });
    node.on('transform', function () {
      updateStateFromNode(node);
      scheduleRender();
    });
  }

  function keepNodeInPrintArea(node) {
    var box = node.getClientRect({ relativeTo: stage, skipShadow: true, skipStroke: true });
    var right = PRINT_AREA.x + PRINT_AREA.width;
    var bottom = PRINT_AREA.y + PRINT_AREA.height;
    if (box.x < PRINT_AREA.x) node.x(node.x() + PRINT_AREA.x - box.x);
    if (box.y < PRINT_AREA.y) node.y(node.y() + PRINT_AREA.y - box.y);
    if (box.x + box.width > right) node.x(node.x() - (box.x + box.width - right));
    if (box.y + box.height > bottom) node.y(node.y() - (box.y + box.height - bottom));
  }

  function startInlineTextEdit(node) {
    var item = objectById(node.id());
    if (!item || item.type !== 'text' || root.querySelector('.csd__inline-text-editor')) return;
    var stageBox = stage.container().getBoundingClientRect();
    var nodeBox = node.getClientRect({ relativeTo: stage, skipShadow: true, skipStroke: true });
    var scale = stage.scaleX() || 1;
    var originalText = item.text;
    var originalWidth = item.width;
    var originalNodeWidth = node.width();
    var originalPosition = { x: node.x(), y: node.y(), itemX: item.x, itemY: item.y };
    var originalRotation = { node: node.rotation(), item: item.rotation || 0 };
    var editor = document.createElement('input');
    editor.type = 'text';
    editor.className = 'csd__inline-text-editor';
    editor.value = item.text;
    editor.setAttribute('aria-label', 'Edit selected sleeve text');
    editor.style.left = Math.round(window.scrollX + stageBox.left + nodeBox.x * scale) + 'px';
    editor.style.top = Math.round(window.scrollY + stageBox.top + nodeBox.y * scale) + 'px';
    editor.style.width = Math.max(90, Math.round(nodeBox.width * scale)) + 'px';
    editor.style.height = Math.max(34, Math.round(nodeBox.height * scale)) + 'px';
    editor.style.fontFamily = item.fontFamily;
    editor.style.fontSize = Math.max(14, item.fontSize * HEIGHT * scale) + 'px';
    editor.style.fontWeight = (item.fontStyle || '').indexOf('bold') !== -1 ? '700' : '400';
    editor.style.fontStyle = (item.fontStyle || '').indexOf('italic') !== -1 ? 'italic' : 'normal';
    editor.style.color = item.fill;
    document.body.appendChild(editor);
    node.hide();
    transformer.hide();
    artLayer.draw();
    editor.focus();
    editor.select();

    var finished = false;
    function preservePosition() {
      node.position({ x: originalPosition.x, y: originalPosition.y });
      node.rotation(originalRotation.node);
      item.x = originalPosition.itemX;
      item.y = originalPosition.itemY;
      item.rotation = originalRotation.item;
    }
    function finish(cancel) {
      if (finished) return;
      finished = true;
      if (!cancel) {
        item.text = editor.value || ' ';
        node.text(item.text);
        fitTextNode(node);
        item.width = node.width() / WIDTH;
        textValue.value = item.text;
        node.offsetY(node.height() / 2);
        preservePosition();
        commit();
      } else {
        item.text = originalText;
        item.width = originalWidth;
        node.text(originalText);
        node.width(originalNodeWidth);
        node.offsetX(node.width() / 2);
        node.offsetY(node.height() / 2);
        preservePosition();
        textValue.value = originalText;
        scheduleRender();
      }
      editor.remove();
      node.show();
      transformer.show();
      selectNode(node);
    }
    editor.addEventListener('input', function () {
      item.text = editor.value || ' ';
      node.text(item.text);
      fitTextNode(node);
      preservePosition();
      textValue.value = item.text;
      scheduleRender();
    });
    editor.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        finish(false);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        finish(true);
      }
    });
    editor.addEventListener('blur', function () { finish(false); });
  }

  function normalizeTransformedNode(node) {
    var item = objectById(node.id());
    if (!item) return;
    var scaleX = Math.abs(node.scaleX());
    var scaleY = Math.abs(node.scaleY());
    if (item.type === 'image') {
      node.width(Math.max(24, node.width() * scaleX));
      node.height(Math.max(12, node.height() * scaleY));
    } else {
      node.width(Math.max(32, node.width() * scaleX));
      node.fontSize(Math.max(8, node.fontSize() * scaleY));
    }
    node.scale({ x: 1, y: 1 });
    node.offsetX(node.width() / 2);
    node.offsetY(node.height() / 2);
  }

  function updateStateFromNode(node) {
    var item = objectById(node.id());
    if (!item) return;
    item.x = node.x() / WIDTH;
    item.y = node.y() / HEIGHT;
    item.rotation = Math.round(node.rotation() * 10) / 10;

    if (item.type === 'image') {
      item.width = node.width() * Math.abs(node.scaleX()) / WIDTH;
      item.height = node.height() * Math.abs(node.scaleY()) / HEIGHT;
    } else {
      item.width = node.width() * Math.abs(node.scaleX()) / WIDTH;
      item.fontSize = node.fontSize() * Math.abs(node.scaleY()) / HEIGHT;
    }
    updateSelectionControls(item);
  }

  function buildStage() {
    if (stage) stage.destroy();
    canvasHost.innerHTML = '';
    stage = new Konva.Stage({ container: canvasHost, width: WIDTH, height: HEIGHT });
    artLayer = new Konva.Layer();
    stage.add(artLayer);

    artLayer.add(new Konva.Rect({
      name: 'csd-background',
      x: 0,
      y: 0,
      width: WIDTH,
      height: HEIGHT,
      fill: activeState().background,
      listening: false
    }));

    activeState().objects.forEach(function (item) {
      var node = nodeFromState(item);
      if (node) artLayer.add(node);
    });

    artLayer.add(new Konva.Rect({
      x: PRINT_AREA.x,
      y: PRINT_AREA.y,
      width: PRINT_AREA.width,
      height: PRINT_AREA.height,
      stroke: 'rgba(35, 50, 46, .42)',
      strokeWidth: 1,
      dash: [6, 5],
      listening: false
    }));

    transformer = new Konva.Transformer({
      rotateEnabled: true,
      keepRatio: true,
      flipEnabled: false,
      borderStroke: '#e96632',
      borderStrokeWidth: 1,
      anchorFill: '#ffffff',
      anchorStroke: '#e96632',
      anchorStrokeWidth: 2,
      anchorSize: 12,
      anchorCornerRadius: 6,
      padding: 0,
      rotateAnchorOffset: 16,
      enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
      boundBoxFunc: function (oldBox, newBox) {
        var scale = stage.scaleX() || 1;
        if (Math.abs(newBox.width) < 24 * scale || Math.abs(newBox.height) < 12 * scale) return oldBox;
        return newBox;
      }
    });
    artLayer.add(transformer);
    stage.on('click tap', function (event) {
      if (event.target === transformer || event.target.getParent() === transformer) return;
      if (event.target === stage || !event.target.getAttr('csdType')) clearSelection();
    });
    fitStage();
    artLayer.draw();
    clearSelection();
    renderObjectList();
    printColorInput.value = activeState().background;
  }

  function fitStage() {
    if (!stage) return;
    var shell = canvasHost.parentNode;
    var shellStyle = window.getComputedStyle(shell);
    var horizontalPadding =
      (parseFloat(shellStyle.paddingLeft) || 0) +
      (parseFloat(shellStyle.paddingRight) || 0);
    var available = shell.clientWidth - horizontalPadding;
    var scale = Math.max(.3, Math.min(1.55, available / WIDTH));
    var displayWidth = Math.round(WIDTH * scale);
    var displayHeight = Math.round(HEIGHT * scale);
    stage.width(displayWidth);
    stage.height(displayHeight);
    stage.scale({ x: scale, y: scale });
    canvasHost.style.width = displayWidth + 'px';
    canvasHost.style.height = displayHeight + 'px';
    syncDimensionMarker();
    window.requestAnimationFrame(syncDimensionMarker);
    if (transformer) transformer.forceUpdate();
    artLayer.batchDraw();
  }

  function initMobileGuidance() {
    if (!editorPanel || !mobileGuidance || !mobileGuidanceDismiss) return;

    var coarsePointer = window.matchMedia ?
      window.matchMedia('(pointer: coarse)') :
      { matches: false };
    var dismissed = false;

    try {
      dismissed = window.sessionStorage.getItem(MOBILE_GUIDANCE_KEY) === 'true';
    } catch (error) {
      dismissed = false;
    }

    function updateGuidance() {
      var shouldShow = !dismissed && coarsePointer.matches && editorPanel.clientWidth < 600;
      mobileGuidance.hidden = !shouldShow;
    }

    mobileGuidanceDismiss.addEventListener('click', function() {
      dismissed = true;
      mobileGuidance.hidden = true;
      try {
        window.sessionStorage.setItem(MOBILE_GUIDANCE_KEY, 'true');
      } catch (error) {
        // Storage can be unavailable in privacy modes; dismissal still lasts for this page.
      }
    });

    if (coarsePointer.addEventListener) {
      coarsePointer.addEventListener('change', updateGuidance);
    } else if (coarsePointer.addListener) {
      coarsePointer.addListener(updateGuidance);
    }

    if (window.ResizeObserver) {
      var editorResizeObserver = new ResizeObserver(function() {
        updateGuidance();
        fitStage();
      });
      editorResizeObserver.observe(editorPanel);
    } else {
      window.addEventListener('resize', updateGuidance);
    }

    updateGuidance();
  }

  function syncDimensionMarker() {
    var shell = canvasHost.parentNode;
    var shellBox = shell.getBoundingClientRect();
    var sleeveBox = canvasHost.getBoundingClientRect();
    shell.style.setProperty('--csd-sleeve-left', (sleeveBox.left - shellBox.left) + 'px');
    shell.style.setProperty('--csd-sleeve-width', sleeveBox.width + 'px');
  }

  function selectNode(node) {
    selectedId = node.id();
    transformer.nodes([node]);
    transformer.moveToTop();
    selectionPanel.classList.remove('is-hidden');
    updateSelectionControls(objectById(selectedId));
    stage.container().classList.add('is-object-selected');
    renderObjectList();
    artLayer.draw();
  }

  function clearSelection() {
    selectedId = null;
    if (transformer) transformer.nodes([]);
    if (stage) stage.container().classList.remove('is-object-selected');
    selectionPanel.classList.add('is-hidden');
    logoLabel.textContent = 'Upload logo';
    renderObjectList();
    if (artLayer) artLayer.draw();
  }

  function objectLabel(item, index) {
    if (item.type === 'image') return 'Logo ' + (index + 1);
    var text = (item.text || 'Text').replace(/\s+/g, ' ').trim();
    return text.length > 26 ? text.slice(0, 25) + '…' : text;
  }

  function renderObjectList() {
    if (!objectList) return;
    objectList.innerHTML = '';
    activeState().objects.forEach(function (item, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('data-csd-object-id', item.id);
      button.className = item.id === selectedId ? 'is-active' : '';
      var type = document.createElement('i');
      type.textContent = item.type === 'image' ? '▧' : 'T';
      var label = document.createElement('span');
      label.textContent = objectLabel(item, index);
      button.appendChild(type);
      button.appendChild(label);
      objectList.appendChild(button);
    });
  }

  function selectObjectById(objectId) {
    selectedId = objectId;
    var node = artLayer.findOne('#' + objectId);
    if (node) selectNode(node);
    else renderObjectList();
  }

  function updateSelectionControls(item) {
    if (!item) return;
    var isText = item.type === 'text';
    for (var i = 0; i < textControlGroups.length; i++) {
      textControlGroups[i].classList.toggle('is-hidden', !isText);
    }
    if (isText) {
      textValue.value = item.text;
      fontSelect.value = item.fontFamily;
      colorInput.value = item.fill;
      fontSizeInput.value = Math.round(item.fontSize * HEIGHT);
      letterSpacingInput.value = Math.round((item.letterSpacing || 0) * HEIGHT * 10) / 10;
      boldButton.setAttribute('aria-pressed', (item.fontStyle || '').indexOf('bold') !== -1 ? 'true' : 'false');
      italicButton.setAttribute('aria-pressed', (item.fontStyle || '').indexOf('italic') !== -1 ? 'true' : 'false');
      logoLabel.textContent = 'Upload logo';
    } else {
      logoLabel.textContent = 'Replace logo';
    }
    printColorInput.value = activeState().background;
  }

  function historySnapshot() {
    return JSON.stringify(design);
  }

  function commit(skipHistory) {
    design.updatedAt = new Date().toISOString();
    if (!skipHistory && !historyLocked) {
      var snapshot = historySnapshot();
      if (history[historyIndex] !== snapshot) {
        history = history.slice(0, historyIndex + 1);
        history.push(snapshot);
        historyIndex = history.length - 1;
        if (history.length > 30) {
          history.shift();
          historyIndex--;
        }
      }
    }
    updateHistoryButtons();
    saveLocally();
    scheduleRender();
    root.dispatchEvent(new CustomEvent('csd:design-change'));
  }

  function saveLocally() {
    saveState.textContent = 'Saving…';
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(design));
      saveState.textContent = 'Saved on this device';
    } catch (error) {
      saveState.textContent = 'Preview ready';
    }
  }

  function updateHistoryButtons() {
    undoButton.disabled = historyIndex <= 0;
    redoButton.disabled = historyIndex >= history.length - 1;
  }

  function restoreHistory(index) {
    if (index < 0 || index >= history.length) return;
    historyLocked = true;
    historyIndex = index;
    design = JSON.parse(history[historyIndex]);
    buildStage();
    setActiveSample(design.selectedSample);
    historyLocked = false;
    updateHistoryButtons();
    saveLocally();
    scheduleRender();
  }

  function setSide(side) {
    if (viewer && viewer.setView) viewer.setView(side);
    if (side === activeSide) return;
    activeSide = side;
    root.querySelectorAll('[data-csd-side]').forEach(function (button) {
      var active = button.getAttribute('data-csd-side') === side;
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    buildStage();
    printColorInput.value = activeState().background;
    updateColorWarning();
  }

  function addText() {
    var item = textObject('Your text', .5, .5, .34, .17, 'Georgia', '#202020');
    activeState().objects.push(item);
    buildStage();
    var node = artLayer.findOne('#' + item.id);
    if (node) selectNode(node);
    commit();
  }

  function trimLogoImage(image) {
    var source = document.createElement('canvas');
    source.width = image.naturalWidth || image.width;
    source.height = image.naturalHeight || image.height;
    var context = source.getContext('2d', { willReadFrequently: true });
    context.drawImage(image, 0, 0);
    var pixels = context.getImageData(0, 0, source.width, source.height).data;
    var left = source.width;
    var right = -1;
    var top = source.height;
    var bottom = -1;
    for (var y = 0; y < source.height; y++) {
      for (var x = 0; x < source.width; x++) {
        if (pixels[(y * source.width + x) * 4 + 3] < 8) continue;
        if (x < left) left = x;
        if (x > right) right = x;
        if (y < top) top = y;
        if (y > bottom) bottom = y;
      }
    }
    if (right < left || bottom < top || (left === 0 && top === 0 && right === source.width - 1 && bottom === source.height - 1)) {
      return source;
    }
    var trimmed = document.createElement('canvas');
    trimmed.width = right - left + 1;
    trimmed.height = bottom - top + 1;
    trimmed.getContext('2d').drawImage(source, left, top, trimmed.width, trimmed.height, 0, 0, trimmed.width, trimmed.height);
    return trimmed;
  }

  function handleLogo(file) {
    if (!file || !/^image\/(png|jpeg|webp)$/.test(file.type) || file.size > 10 * 1024 * 1024) {
      showNotice('Please choose a PNG, JPG, or WebP image under 10 MB.', true);
      logoInput.value = '';
      return;
    }
    pendingUploads++;
    uploadError = '';
    function failed() {
      pendingUploads--;
      uploadError = 'This image could not be read. Please choose a valid PNG, JPG, or WebP image.';
      showNotice(uploadError, true);
    }
    var reader = new FileReader();
    reader.onerror = failed;
    reader.onload = function () {
      var image = new Image();
      image.onerror = failed;
      image.onload = function () {
        try {
          var logoImage = trimLogoImage(image);
          var imageScale = Math.min((WIDTH * .34) / logoImage.width, (HEIGHT * .5) / logoImage.height);
          var targetWidth = logoImage.width * imageScale / WIDTH;
          var targetHeight = logoImage.height * imageScale / HEIGHT;
          var logoDataUrl = logoImage.toDataURL('image/png');
          var selected = objectById(selectedId);
          var item;
          if (selected && selected.type === 'image') {
            item = selected;
            item.dataUrl = logoDataUrl;
            delete item.assetUrl;
            delete item.pdfSample;
            delete item.crop;
            item.originalName = file.name;
            item.width = targetWidth;
            item.height = targetHeight;
            imageCache[item.id] = logoImage;
          } else {
            item = {
              id: id('logo'),
              type: 'image',
              dataUrl: logoDataUrl,
              originalName: file.name,
              x: .5,
              y: .5,
              width: targetWidth,
              height: targetHeight,
              rotation: 0
            };
            activeState().objects.push(item);
            imageCache[item.id] = logoImage;
          }
          item.tooManyColors = imageUsesMoreThanTwoColors(logoImage);
          selectedId = item.id;
          buildStage();
          var node = artLayer.findOne('#' + item.id);
          if (node) selectNode(node);
          commit();
          updateColorWarning();
          logoInput.value = '';
        } catch (error) {
          uploadError = 'This image could not be prepared. Please choose another image.';
          showNotice(uploadError, true);
        }
        finally { pendingUploads--; }
      };
      image.src = reader.result;
    };
    reader.readAsDataURL(file);
  }

  function deleteSelected() {
    if (!selectedId) return;
    activeState().objects = activeState().objects.filter(function (item) {
      return item.id !== selectedId;
    });
    delete imageCache[selectedId];
    buildStage();
    commit();
  }

  function snapSelected(zone) {
    var item = objectById(selectedId);
    if (!item) return;
    item.x = zone === 'left' ? .2 : zone === 'right' ? .8 : .5;
    var node = artLayer.findOne('#' + item.id);
    if (node) node.x(item.x * WIDTH);
    artLayer.draw();
    commit();
  }

  function updateSelectedText() {
    var item = objectById(selectedId);
    if (!item || item.type !== 'text') return;
    item.text = textValue.value || ' ';
    var node = artLayer.findOne('#' + item.id);
    if (node) {
      node.text(item.text);
      fitTextNode(node);
      item.width = node.width() / WIDTH;
      transformer.forceUpdate();
      artLayer.draw();
    }
    var selectedButton = objectList.querySelector('[data-csd-object-id].is-active');
    if (selectedButton && selectedButton.getAttribute('data-csd-object-id') === item.id) {
      selectedButton.querySelector('span').textContent = objectLabel(item, activeState().objects.indexOf(item));
    }
    scheduleRender();
  }

  function finishTextChange() {
    updateSelectedText();
    commit();
  }

  function setSelectedFont() {
    var item = objectById(selectedId);
    if (!item || item.type !== 'text') return;
    item.fontFamily = fontSelect.value;
    var node = artLayer.findOne('#' + item.id);
    if (node) node.fontFamily(item.fontFamily);
    artLayer.draw();
    commit();
  }

  function setSelectedColor() {
    var item = objectById(selectedId);
    if (!item || item.type !== 'text') return;
    item.fill = colorInput.value;
    var node = artLayer.findOne('#' + item.id);
    if (node) node.fill(item.fill);
    artLayer.draw();
    updateColorWarning();
    scheduleRender();
  }

  function setSelectedFontSize(commitChange) {
    var item = objectById(selectedId);
    if (!item || item.type !== 'text') return;
    item.fontSize = Number(fontSizeInput.value) / HEIGHT;
    var node = artLayer.findOne('#' + item.id);
    if (node) {
      node.fontSize(item.fontSize * HEIGHT);
      node.offsetY(node.height() / 2);
      transformer.forceUpdate();
    }
    artLayer.draw();
    if (commitChange) commit();
    else scheduleRender();
  }

  function setSelectedLetterSpacing(commitChange) {
    var item = objectById(selectedId);
    if (!item || item.type !== 'text') return;
    item.letterSpacing = Number(letterSpacingInput.value) / HEIGHT;
    var node = artLayer.findOne('#' + item.id);
    if (node) {
      node.letterSpacing(item.letterSpacing * HEIGHT);
      transformer.forceUpdate();
    }
    artLayer.draw();
    if (commitChange) commit();
    else scheduleRender();
  }

  function toggleTextStyle(style) {
    var item = objectById(selectedId);
    if (!item || item.type !== 'text') return;
    var styles = (item.fontStyle || '').split(/\s+/).filter(function (value) {
      return value && value !== 'normal';
    });
    var index = styles.indexOf(style);
    if (index === -1) styles.push(style);
    else styles.splice(index, 1);
    item.fontStyle = styles.join(' ') || 'normal';
    var node = artLayer.findOne('#' + item.id);
    if (node) {
      node.fontStyle(item.fontStyle);
      transformer.forceUpdate();
    }
    updateSelectionControls(item);
    artLayer.draw();
    commit();
  }

  function setPrintColor() {
    activeState().background = printColorInput.value;
    var background = artLayer.findOne('.csd-background');
    if (background) background.fill(activeState().background);
    else buildStage();
    updateColorWarning();
    commit();
  }

  function imageUsesMoreThanTwoColors(image) {
    var sample = document.createElement('canvas');
    sample.width = 40;
    sample.height = 40;
    var context = sample.getContext('2d', { willReadFrequently: true });
    context.drawImage(image, 0, 0, sample.width, sample.height);
    var pixels = context.getImageData(0, 0, sample.width, sample.height).data;
    var colors = {};
    for (var i = 0; i < pixels.length; i += 4) {
      if (pixels[i + 3] < 40) continue;
      var key = Math.round(pixels[i] / 48) + '-' + Math.round(pixels[i + 1] / 48) + '-' + Math.round(pixels[i + 2] / 48);
      colors[key] = true;
      if (Object.keys(colors).length > 2) return true;
    }
    return false;
  }

  function updateColorWarning() {
    var colors = {};
    var tooManyArtworkColors = false;
    ['front', 'back'].forEach(function (side) {
      colors[design.sides[side].background.toLowerCase()] = true;
      design.sides[side].objects.forEach(function (item) {
        if (item.type === 'text') colors[item.fill.toLowerCase()] = true;
        if (item.type === 'image' && item.tooManyColors) tooManyArtworkColors = true;
      });
    });
    colorWarning.classList.toggle('is-hidden', Object.keys(colors).length <= 2 && !tooManyArtworkColors);
  }

  function handleEditorKeys(event) {
    if (root.inert || !selectedId || event.defaultPrevented) return;
    var target = event.target;
    if (target && (/^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName) || target.isContentEditable)) return;
    if (event.key === 'Delete' || event.key === 'Backspace') {
      event.preventDefault();
      deleteSelected();
      return;
    }
    var movement = event.shiftKey ? 5 : 1;
    var dx = event.key === 'ArrowLeft' ? -movement : event.key === 'ArrowRight' ? movement : 0;
    var dy = event.key === 'ArrowUp' ? -movement : event.key === 'ArrowDown' ? movement : 0;
    if (!dx && !dy) return;
    event.preventDefault();
    var node = artLayer.findOne('#' + selectedId);
    if (!node) return;
    node.x(node.x() + dx);
    node.y(node.y() + dy);
    keepNodeInPrintArea(node);
    updateStateFromNode(node);
    artLayer.draw();
    commit();
  }

  function resetSide() {
    var sample = samples[design.selectedSample];
    design.sides[activeSide] = clone(
      (sample || { front: { background: '#ffffff', objects: [] }, back: { background: '#ffffff', objects: [] } })[activeSide]
    );
    buildStage();
    commit();
    updateColorWarning();
  }

  function setActiveSample(key) {
    root.querySelectorAll('[data-csd-sample]').forEach(function (button) {
      var isActive = button.getAttribute('data-csd-sample') === key;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function loadSample(key) {
    var sample = samples[key];
    var button = root.querySelector('[data-csd-sample="' + key + '"]');
    if (!sample || !button) return;
    if (history.length > 1 && !window.confirm('Replace your current front and back design with this sample?')) return;
    design.selectedSample = key;
    design.sides.front = clone(sample.front);
    design.sides.back = clone(sample.back);
    selectedId = null;
    setActiveSample(key);
    buildStage();
    commit();
    updateColorWarning();
    setInspirationOpen(false);
  }

  function setInspirationOpen(open) {
    var inspiration = root.querySelector('[data-csd-inspiration]');
    var toggle = root.querySelector('[data-csd-inspiration-toggle]');
    if (!inspiration || !toggle) return;
    inspiration.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function drawState(state, canvas) {
    var context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = state.background;
    context.fillRect(0, 0, canvas.width, canvas.height);

    state.objects.forEach(function (item) {
      context.save();
      context.translate(item.x * canvas.width, item.y * canvas.height);
      context.rotate((item.rotation || 0) * Math.PI / 180);
      if (item.type === 'text') {
        var previewText = new Konva.Text({
          width: item.width * canvas.width,
          text: item.text,
          fill: item.fill,
          fontFamily: item.fontFamily,
          fontStyle: item.fontStyle || 'normal',
          fontSize: item.fontSize * canvas.height,
          letterSpacing: (item.letterSpacing || 0) * canvas.height,
          align: item.align || 'center',
          verticalAlign: 'middle',
          wrap: 'none'
        });
        var textWidth = previewText.width();
        var textHeight = previewText.height();
        var textCanvas = previewText.toCanvas({
          x: 0,
          y: 0,
          width: textWidth,
          height: textHeight,
          pixelRatio: 2
        });
        context.drawImage(textCanvas, -textWidth / 2, -textHeight / 2, textWidth, textHeight);
        previewText.destroy();
      } else if (item.type === 'image' && (item.dataUrl || item.assetUrl || item.pdfSample)) {
        var image = imageCache[item.id];
        if (image && (image.complete || image.getContext)) {
          context.drawImage(
            image,
            -item.width * canvas.width / 2,
            -item.height * canvas.height / 2,
            item.width * canvas.width,
            item.height * canvas.height
          );
        } else {
          loadArtworkImage(item, function () {});
        }
      }
      context.restore();
    });
  }

  function drawSide(side, canvas) {
    drawState(design.sides[side], canvas);
  }

  function renderViewerTextures() {
    var hoveredSample = hoveredSampleKey && samples[hoveredSampleKey];
    ['front', 'back'].forEach(function (side) {
      var viewerContext = viewerCanvases[side].getContext('2d');
      if (hoveredSample) {
        drawState(hoveredSample[side], viewerCanvases[side]);
      } else {
        viewerContext.clearRect(0, 0, viewerCanvases[side].width, viewerCanvases[side].height);
        viewerContext.drawImage(proofCanvases[side], 0, 0);
      }
    });
    if (viewer) viewer.updateTextures();
  }

  function previewSample(key) {
    if (!samples[key] || key === design.selectedSample) return;
    hoveredSampleKey = key;
    root.querySelector('[data-csd-viewer]').classList.add('is-sample-previewing');
    renderViewerTextures();
  }

  function clearSamplePreview() {
    if (!hoveredSampleKey) return;
    hoveredSampleKey = null;
    root.querySelector('[data-csd-viewer]').classList.remove('is-sample-previewing');
    renderViewerTextures();
  }

  function scheduleRender() {
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(renderOutputs, 40);
  }

  function renderOutputs() {
    drawSide('front', proofCanvases.front);
    drawSide('back', proofCanvases.back);
    renderViewerTextures();
    if (orderPreview) {
      var orderPreviewContext = orderPreview.getContext('2d');
      var previewHalfHeight = orderPreview.height / 2;
      orderPreviewContext.clearRect(0, 0, orderPreview.width, orderPreview.height);
      orderPreviewContext.fillStyle = '#f3f2ee';
      orderPreviewContext.fillRect(0, 0, orderPreview.width, orderPreview.height);
      orderPreviewContext.drawImage(
        proofCanvases.front,
        0,
        0,
        proofCanvases.front.width,
        proofCanvases.front.height,
        0,
        1,
        orderPreview.width,
        previewHalfHeight - 2
      );
      orderPreviewContext.drawImage(
        proofCanvases.back,
        0,
        0,
        proofCanvases.back.width,
        proofCanvases.back.height,
        0,
        previewHalfHeight + 1,
        orderPreview.width,
        previewHalfHeight - 2
      );
    }
    var summaryField = root.querySelector('[data-csd-design-summary]');
    var referenceField = root.querySelector('[data-csd-design-reference]');
    if (!orderForm || orderForm.dataset.csdReceiptReady !== 'true') {
      if (summaryField) summaryField.value = designSummary();
      if (referenceField) referenceField.value = design.designReference;
    }
  }

  function placementName(x) {
    if (x < .35) return 'left';
    if (x > .65) return 'right';
    return 'center';
  }

  function designSummary() {
    var lines = [
      'Design ID: ' + design.designReference,
      'Sample: ' + ((samples[design.selectedSample] && samples[design.selectedSample].name) || design.selectedSample || 'Custom')
    ];
    ['front', 'back'].forEach(function (side) {
      var sideState = design.sides[side];
      lines.push(side.charAt(0).toUpperCase() + side.slice(1) + ' background: ' + sideState.background);
      sideState.objects.forEach(function (item, index) {
        var placement = placementName(item.x) + ' (' + Math.round(item.x * 100) + '%, ' + Math.round(item.y * 100) + '%)';
        if (item.type === 'text') {
          lines.push(
            side + ' text ' + (index + 1) + ': "' + item.text.replace(/\s+/g, ' ').trim() + '"' +
            ' | font: ' + item.fontFamily +
            ' | color: ' + item.fill +
            ' | placement: ' + placement +
            ' | rotation: ' + Math.round(item.rotation || 0) + '°'
          );
        } else if (item.type === 'image') {
          lines.push(
            side + ' artwork: ' + (item.pdfSample
              ? 'stock sample ' + item.pdfSample + ' — ' + item.originalName
              : item.dataUrl ? 'customer upload — ' + (item.originalName || 'logo') : 'stock asset — ' + item.assetUrl) +
            ' | placement: ' + placement +
            ' | rotation: ' + Math.round(item.rotation || 0) + '°'
          );
        }
      });
    });
    return lines.join('\n').slice(0, 4000);
  }

  function wrapText(context, text, x, y, maxWidth, lineHeight) {
    var words = text.split(/\s+/);
    var line = '';
    for (var i = 0; i < words.length; i++) {
      var testLine = line ? line + ' ' + words[i] : words[i];
      if (context.measureText(testLine).width > maxWidth && line) {
        context.fillText(line, x, y);
        line = words[i];
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    if (line) context.fillText(line, x, y);
    return y + lineHeight;
  }

  function createDownloadCanvas() {
    renderOutputs();
    var exportCanvas = document.createElement('canvas');
    exportCanvas.width = 1600;
    exportCanvas.height = 1750;
    var context = exportCanvas.getContext('2d');
    var sampleName = (samples[design.selectedSample] && samples[design.selectedSample].name) || 'Custom';

    context.fillStyle = '#f7f4ed';
    context.fillRect(0, 0, exportCanvas.width, exportCanvas.height);
    context.fillStyle = '#173f3a';
    context.font = '700 54px Georgia, serif';
    context.fillText('ERS Custom Chopstick Sleeve', 100, 100);
    context.font = '24px Arial, sans-serif';
    context.fillStyle = '#687672';
    context.fillText('Design ' + design.designReference + '  •  ' + sampleName, 100, 148);

    context.fillStyle = '#ffffff';
    context.fillRect(100, 205, 1400, 420);
    context.fillStyle = '#173f3a';
    context.font = '700 22px Arial, sans-serif';
    context.fillText('CUSTOMER DESIGN PREVIEW', 130, 250);
    var viewerCanvas = root.querySelector('[data-csd-viewer] canvas');
    if (viewerCanvas) {
      context.drawImage(viewerCanvas, 130, 275, 1340, 315);
    } else {
      context.drawImage(proofCanvases.front, 240, 365, 1120, 140);
    }

    context.fillStyle = '#173f3a';
    context.font = '700 22px Arial, sans-serif';
    context.fillText('FRONT', 100, 700);
    context.drawImage(proofCanvases.front, 100, 730, 1400, 175);
    context.fillText('BACK', 100, 970);
    context.drawImage(proofCanvases.back, 100, 1000, 1400, 175);

    context.fillStyle = '#173f3a';
    context.font = '700 22px Arial, sans-serif';
    context.fillText('DESIGN SUMMARY', 100, 1245);
    context.fillStyle = '#3f4c49';
    context.font = '20px Arial, sans-serif';
    var summaryLines = designSummary().split('\n');
    var y = 1285;
    for (var i = 0; i < summaryLines.length && y < 1690; i++) {
      y = wrapText(context, summaryLines[i], 100, y, 1400, 28);
    }
    return exportCanvas;
  }

  function downloadPreview() {
    var exportCanvas = createDownloadCanvas();
    exportCanvas.toBlob(function (blob) {
      if (!blob) return;
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = design.designReference + '-chopstick-sleeve-preview.png';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    }, 'image/png');
  }

  function showNotice(message, isError) {
    if (isError && orderError) {
      showOrderError(message);
      return;
    }
    if (saveState) saveState.textContent = message;
  }

  function selectedArtworkSource() {
    var selected = root.querySelector('[data-csd-artwork-source]:checked');
    return selected ? selected.getAttribute('data-csd-artwork-source') : 'design';
  }

  function productVariants() {
    var script = root.querySelector('[data-csd-product-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function updateGalleryProductInfo() {
    var selectedChopstick = root.querySelector('input[name="contact[Chopstick type]"]:checked');
    if (!selectedChopstick) return;

    var variantId = selectedChopstick.getAttribute('data-csd-variant-id');
    var variant = productVariants().find(function (item) {
      return String(item.id) === String(variantId);
    });
    if (!variant) return;

    var sku = root.querySelector('[data-csd-gallery-sku]');
    var price = root.querySelector('[data-csd-gallery-price]');
    if (price) price.textContent = variant.priceFormatted;
    if (sku) {
      sku.textContent = variant.sku ? 'SKU: ' + variant.sku : '';
      sku.hidden = !variant.sku;
    }
  }

  function updateOrderSummary() {
    var source = selectedArtworkSource();
    var artworkSummary = root.querySelector('[data-csd-summary-artwork]');
    var chopstickSummary = root.querySelector('[data-csd-summary-chopstick]');
    var quantitySummary = root.querySelector('[data-csd-summary-quantity]');
    var selectedChopstick = root.querySelector('input[name="contact[Chopstick type]"]:checked');
    var quantity = Math.max(7, parseInt(quantityInput && quantityInput.value, 10) || 7);

    if (artworkSummary) {
      artworkSummary.textContent =
        source === 'different' ? 'Different artwork upload' :
        source === 'logo' ? 'Logo only' :
        'My design (front & back)';
    }
    if (chopstickSummary && selectedChopstick) chopstickSummary.textContent = selectedChopstick.value;
    if (quantitySummary) quantitySummary.textContent = quantity + (quantity === 1 ? ' case' : ' cases');
    updateGalleryProductInfo();
  }

  function updateArtworkSource() {
    var source = selectedArtworkSource();
    var differentUpload = root.querySelector('[data-csd-different-upload]');
    var logoUpload = root.querySelector('[data-csd-logo-upload]');
    if (differentUpload) differentUpload.classList.toggle('is-hidden', source !== 'different');
    if (logoUpload) logoUpload.classList.toggle('is-hidden', source !== 'logo');
    if (orderArtworkInput) {
      orderArtworkInput.required = source === 'different';
      orderArtworkInput.disabled = source !== 'different';
    }
    updateOrderSummary();
  }

  function normalizeQuantity(allowEmpty) {
    if (!quantityInput) return 7;
    var parsed = parseInt(quantityInput.value, 10);
    if (allowEmpty && quantityInput.value === '') {
      updateOrderSummary();
      return 7;
    }
    if (!Number.isFinite(parsed) || parsed < 7) parsed = 7;
    quantityInput.value = parsed;
    quantityInput.setAttribute('aria-valuenow', String(parsed));
    var decreaseButton = root.querySelector('[data-csd-quantity-step="-1"]');
    if (decreaseButton) decreaseButton.disabled = parsed <= 7;
    updateOrderSummary();
    return parsed;
  }

  function showOrderError(message) {
    if (!orderError) return;
    orderError.textContent = message;
    orderError.classList.remove('is-hidden');
    orderError.focus();
  }

  function scrollToOrder() {
    var section = root.querySelector('#submit-custom-order');
    if (!section) return;
    var headerOffset = 16;
    ['#mobileNavBar', '.site-header'].forEach(function (selector) {
      var header = document.querySelector(selector);
      if (!header || window.getComputedStyle(header).display === 'none') return;
      var position = window.getComputedStyle(header).position;
      if (position === 'sticky' || position === 'fixed') {
        headerOffset += header.getBoundingClientRect().height;
      }
    });
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: Math.max(0, section.getBoundingClientRect().top + window.pageYOffset - headerOffset),
      behavior: reducedMotion ? 'auto' : 'smooth'
    });
  }

  function initOrderNavigation() {
    root.querySelectorAll('a[href="#submit-custom-order"], [data-csd-go-to-order]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#submit-custom-order');
        }
        scrollToOrder();
      });
    });

    if (window.location.hash !== '#submit-custom-order') return;
    var scrollAfterInitialization = function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(scrollToOrder);
      });
    };
    if (document.readyState === 'complete') scrollAfterInitialization();
    else window.addEventListener('load', scrollAfterInitialization, { once: true });
  }

  function initBambooSectionAutoScroll() {
    if (window.__ersCsdBambooAutoScrollScheduled) return;
    window.__ersCsdBambooAutoScrollScheduled = true;

    var collectionProductPathPattern =
      /^\/collections\/[^/]+\/products\/custom-chopsticks-with-printed-paper-sleeves\/?$/;
    var normalProductPathPattern = /^\/products\/custom-chopsticks-with-printed-paper-sleeves\/?$/;
    var searchParams = new URLSearchParams(window.location.search);
    var hasSearchContext = ['_pos', '_sid', '_ss'].some(function (parameter) {
      return searchParams.has(parameter);
    });
    var shouldAutoScroll =
      collectionProductPathPattern.test(window.location.pathname) ||
      (normalProductPathPattern.test(window.location.pathname) && hasSearchContext);
    if (!shouldAutoScroll || window.location.hash) return;

    var navigationEntries = window.performance && window.performance.getEntriesByType ?
      window.performance.getEntriesByType('navigation') : [];
    if (navigationEntries[0] && navigationEntries[0].type === 'back_forward') return;

    var target = root.querySelector('[data-csd-auto-scroll-target]');
    if (!target) return;

    var cancelled = false;
    var intentEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    var cancelForUserIntent = function () {
      cancelled = true;
      removeIntentListeners();
    };
    var removeIntentListeners = function () {
      intentEvents.forEach(function (eventName) {
        window.removeEventListener(eventName, cancelForUserIntent, true);
      });
    };

    intentEvents.forEach(function (eventName) {
      window.addEventListener(eventName, cancelForUserIntent, { capture: true, passive: true });
    });

    var scrollAfterInitialization = function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          removeIntentListeners();
          if (cancelled || window.location.hash || window.pageYOffset > 2) return;

          var headerOffset = 16;
          ['#mobileNavBar', '.site-header'].forEach(function (selector) {
            var header = document.querySelector(selector);
            if (!header || window.getComputedStyle(header).display === 'none') return;
            var position = window.getComputedStyle(header).position;
            if (position === 'sticky' || position === 'fixed') {
              headerOffset += header.getBoundingClientRect().height;
            }
          });

          window.scrollTo({
            top: Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - headerOffset),
            behavior: 'smooth'
          });
        });
      });
    };

    if (document.readyState === 'complete') scrollAfterInitialization();
    else window.addEventListener('load', scrollAfterInitialization, { once: true });
  }

  function bindEvents() {
    root.querySelectorAll('[data-csd-side]').forEach(function (button) {
      button.addEventListener('click', function () { setSide(button.getAttribute('data-csd-side')); });
    });
    root.querySelector('[data-csd-add-text]').addEventListener('click', addText);
    logoInput.addEventListener('change', function () {
      var file = logoInput.files[0];
      if (file && /^image\/(png|jpeg|webp)$/.test(file.type) && file.size <= 10 * 1024 * 1024) {
        orderLogoFile = file;
        if (orderLogoName) orderLogoName.textContent = file.name;
      }
      handleLogo(file);
    });
    root.querySelector('[data-csd-delete]').addEventListener('click', deleteSelected);
    root.querySelectorAll('[data-csd-snap]').forEach(function (button) {
      button.addEventListener('click', function () { snapSelected(button.getAttribute('data-csd-snap')); });
    });
    textValue.addEventListener('input', updateSelectedText);
    textValue.addEventListener('change', finishTextChange);
    fontSelect.addEventListener('change', setSelectedFont);
    colorInput.addEventListener('input', setSelectedColor);
    colorInput.addEventListener('change', commit);
    fontSizeInput.addEventListener('input', function () { setSelectedFontSize(false); });
    fontSizeInput.addEventListener('change', function () { setSelectedFontSize(true); });
    letterSpacingInput.addEventListener('input', function () { setSelectedLetterSpacing(false); });
    letterSpacingInput.addEventListener('change', function () { setSelectedLetterSpacing(true); });
    boldButton.addEventListener('click', function () { toggleTextStyle('bold'); });
    italicButton.addEventListener('click', function () { toggleTextStyle('italic'); });
    printColorInput.addEventListener('change', setPrintColor);
    undoButton.addEventListener('click', function () { restoreHistory(historyIndex - 1); });
    redoButton.addEventListener('click', function () { restoreHistory(historyIndex + 1); });
    root.querySelector('[data-csd-reset-side]').addEventListener('click', resetSide);
    root.querySelectorAll('[data-csd-sample]').forEach(function (button) {
      var sampleKey = button.getAttribute('data-csd-sample');
      button.addEventListener('mouseenter', function () { previewSample(sampleKey); });
      button.addEventListener('mouseleave', clearSamplePreview);
      button.addEventListener('click', function () {
        clearSamplePreview();
        loadSample(sampleKey);
      });
    });
    objectList.addEventListener('click', function (event) {
      var button = event.target.closest('[data-csd-object-id]');
      if (button) selectObjectById(button.getAttribute('data-csd-object-id'));
    });
    root.querySelector('[data-csd-download]').addEventListener('click', downloadPreview);
    root.querySelectorAll('[data-csd-artwork-source]').forEach(function (input) {
      input.addEventListener('change', updateArtworkSource);
    });
    root.querySelectorAll('input[name="contact[Chopstick type]"]').forEach(function (input) {
      input.addEventListener('change', updateOrderSummary);
    });
    root.querySelectorAll('[data-csd-quantity-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var quantity = normalizeQuantity(false);
        quantityInput.value = Math.max(7, quantity + parseInt(button.getAttribute('data-csd-quantity-step'), 10));
        normalizeQuantity(false);
      });
    });
    if (quantityInput) {
      quantityInput.addEventListener('input', function () { normalizeQuantity(true); });
      quantityInput.addEventListener('blur', function () { normalizeQuantity(false); });
      quantityInput.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;
        event.preventDefault();
        var quantity = normalizeQuantity(false);
        quantityInput.value = Math.max(7, quantity + (event.key === 'ArrowUp' ? 1 : -1));
        normalizeQuantity(false);
      });
    }
    if (notesInput) {
      notesInput.addEventListener('input', function () {
        var count = root.querySelector('[data-csd-notes-count]');
        if (count) count.textContent = notesInput.value.length + ' / 500';
      });
    }
    var logoTrigger = root.querySelector('[data-csd-order-logo-trigger]');
    if (logoTrigger) logoTrigger.addEventListener('click', function () { logoInput.click(); });
    root.querySelectorAll('[data-csd-gallery-thumb]').forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function (event) {
        event.preventDefault();
        var imageId = thumbnail.getAttribute('data-csd-gallery-thumb');
        root.querySelectorAll('[data-csd-gallery-image]').forEach(function (image) {
          image.classList.toggle('is-hidden', image.getAttribute('data-csd-gallery-image') !== imageId);
        });
        root.querySelectorAll('[data-csd-gallery-thumb]').forEach(function (otherThumbnail) {
          var isActive = otherThumbnail === thumbnail;
          otherThumbnail.classList.toggle('is-active', isActive);
          if (isActive) otherThumbnail.setAttribute('aria-current', 'true');
          else otherThumbnail.removeAttribute('aria-current');
        });
      });
    });
    window.addEventListener('resize', fitStage);
    document.addEventListener('keydown', handleEditorKeys);
  }

  function initViewer() {
    var host = root.querySelector('[data-csd-viewer]');
    var scene = new THREE.Scene();
    var defaultRotation = -.28;
    var camera = new THREE.PerspectiveCamera(24, host.clientWidth / host.clientHeight, .1, 100);

    function frameCamera() {
      camera.aspect = host.clientWidth / host.clientHeight;
      var verticalTangent = Math.tan(THREE.MathUtils.degToRad(camera.fov * .5));
      var horizontalTangent = verticalTangent * camera.aspect;
      var frameFill = host.clientWidth < 600 ? .97 : .92;
      var halfWidth = 3.85;
      var halfHeight = .4;
      var halfDepth = .06;
      var rotationCosine = Math.cos(defaultRotation);
      var rotationSine = Math.sin(defaultRotation);
      var fittedDistance = 0;

      [-halfWidth, halfWidth].forEach(function (x) {
        [-halfDepth, halfDepth].forEach(function (z) {
          var rotatedX = x * rotationCosine + z * rotationSine;
          var rotatedZ = -x * rotationSine + z * rotationCosine;
          fittedDistance = Math.max(
            fittedDistance,
            rotatedZ + Math.max(
              Math.abs(rotatedX) / (horizontalTangent * frameFill),
              halfHeight / (verticalTangent * frameFill)
            )
          );
        });
      });
      camera.position.set(0, .28, fittedDistance + .03);
      camera.lookAt(0, 0, 0);
      camera.updateProjectionMatrix();
    }
    frameCamera();

    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'low-power' });
    } catch (error) {
      host.querySelector('[data-csd-viewer-loading]').textContent = 'Front and back previews are available below.';
      return null;
    }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(host.clientWidth, host.clientHeight);
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    host.appendChild(renderer.domElement);

    var frontTexture = new THREE.CanvasTexture(viewerCanvases.front);
    var backTexture = new THREE.CanvasTexture(viewerCanvases.back);
    frontTexture.colorSpace = THREE.SRGBColorSpace;
    backTexture.colorSpace = THREE.SRGBColorSpace;
    frontTexture.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());
    backTexture.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());

    var sleeve = window.ERSChopstickSleeveGeometry.create(
      THREE,
      frontTexture,
      backTexture
    );
    scene.add(sleeve);

    var ambient = new THREE.HemisphereLight(0xfffdf7, 0xa8aaa4, 1.7);
    scene.add(ambient);
    var key = new THREE.DirectionalLight(0xfff9ef, 2.2);
    key.position.set(-3.5, 4.5, 5);
    key.castShadow = true;
    key.shadow.mapSize.set(1024, 1024);
    key.shadow.camera.near = .1;
    key.shadow.camera.far = 20;
    scene.add(key);
    var fill = new THREE.DirectionalLight(0xe5eced, .65);
    fill.position.set(4, 1, 3);
    scene.add(fill);

    var ground = new THREE.Mesh(
      new THREE.PlaneGeometry(18, 8),
      new THREE.ShadowMaterial({ color: 0x0d2421, opacity: .2 })
    );
    ground.rotation.x = -Math.PI / 2;
    ground.position.y = -.56;
    ground.receiveShadow = true;
    scene.add(ground);

    var targetRotation = defaultRotation;
    var targetTilt = 0;
    var dragging = false;
    var lastX = 0;
    var lastY = 0;
    var dirty = true;

    function render() {
      var rotating = Math.abs(sleeve.rotation.y - targetRotation) > .001;
      var tilting = Math.abs(sleeve.rotation.x - targetTilt) > .001;
      if (rotating || tilting) {
        sleeve.rotation.y += (targetRotation - sleeve.rotation.y) * .14;
        sleeve.rotation.x += (targetTilt - sleeve.rotation.x) * .14;
        dirty = true;
      }
      if (rotating || tilting) {
        requestAnimationFrame(render);
      }
      if (dirty) {
        renderer.render(scene, camera);
        dirty = false;
      }
    }

    function pointerDown(event) {
      dragging = true;
      lastX = event.clientX;
      lastY = event.clientY;
      renderer.domElement.style.cursor = 'grabbing';
      renderer.domElement.setPointerCapture(event.pointerId);
    }

    function pointerMove(event) {
      if (!dragging) return;
      targetRotation += (event.clientX - lastX) * .012;
      targetTilt = Math.max(-.32, Math.min(.32, targetTilt + (event.clientY - lastY) * .006));
      lastX = event.clientX;
      lastY = event.clientY;
      dirty = true;
      render();
    }

    function pointerUp() {
      dragging = false;
      renderer.domElement.style.cursor = 'grab';
    }

    renderer.domElement.style.cursor = 'grab';
    renderer.domElement.addEventListener('pointerdown', pointerDown);
    renderer.domElement.addEventListener('pointermove', pointerMove);
    renderer.domElement.addEventListener('pointerup', pointerUp);
    renderer.domElement.addEventListener('pointercancel', pointerUp);

    root.querySelectorAll('[data-csd-view]').forEach(function (button) {
      button.addEventListener('click', function () {
        var view = button.getAttribute('data-csd-view');
        targetRotation = view === 'front' ? 0 : view === 'back' ? Math.PI : defaultRotation;
        targetTilt = 0;
        dirty = true;
        render();
      });
    });

    function resize() {
      if (!host.clientWidth || !host.clientHeight) return;
      renderer.setSize(host.clientWidth, host.clientHeight);
      frameCamera();
      dirty = true;
      render();
    }
    window.addEventListener('resize', resize);

    host.querySelector('[data-csd-viewer-loading]').remove();
    render();
    return {
      updateTextures: function () {
        frontTexture.needsUpdate = true;
        backTexture.needsUpdate = true;
        dirty = true;
        render();
      },
      setView: function (side) {
        targetRotation = side === 'back' ? Math.PI : 0;
        targetTilt = 0;
        dirty = true;
        render();
      }
    };
  }

  buildStage();
  initMobileGuidance();
  bindEvents();
  setActiveSample(design.selectedSample);
  history.push(historySnapshot());
  historyIndex = 0;
  updateHistoryButtons();
  updateColorWarning();
  updateArtworkSource();
  normalizeQuantity(false);
  renderOutputs();
  viewer = initViewer();
  scheduleRender();
  initOrderNavigation();
  initBambooSectionAutoScroll();

  // Submission consumes the same artwork used by the editor, after every image
  // has loaded. Never persist a proof with a silently missing asynchronous logo.
  root.csdDesigner = {
    getDesign: function () { return clone(design); },
    restoreAttempt: function (saved) {
      if (!saved) return;
      design = clone(saved);
      imageCache = {};
      selectedId = null;
      buildStage();
      setActiveSample(design.selectedSample);
      history = [historySnapshot()]; historyIndex = 0;
      updateHistoryButtons(); updateColorWarning(); renderOutputs();
    },
    setReference: function (reference) {
      design.designReference = reference;
      saveLocally();
      renderOutputs();
    },
    prepareProof: function () {
      return new Promise(function (resolve, reject) {
        var started = Date.now();
        function check() {
          if (uploadError) { reject(new Error(uploadError)); return; }
          if (Date.now() - started > 15000) {
            reject(new Error('Your artwork is still loading. Your design is preserved; please check your connection and try again.'));
            return;
          }
          var ready = pendingUploads === 0;
          ['front', 'back'].forEach(function (side) {
            design.sides[side].objects.forEach(function (item) {
              if (item.type !== 'image') return;
              var image = imageCache[item.id];
              if (!image || !(image.complete || image.getContext)) {
                ready = false;
                loadArtworkImage(item, function () {});
              }
            });
          });
          if (!ready) { window.setTimeout(check, 50); return; }
          document.fonts.ready.then(function () { renderOutputs(); resolve(proofCanvases); }, reject);
        }
        check();
      });
    }
  };

  function initGuidedRecommendation() {
    var dialog = root.querySelector('[data-csd-guided-dialog]');
    var reminder = root.querySelector('[data-csd-guided-reminder]');
    if (!dialog || !reminder || typeof dialog.showModal !== 'function') return;
    var previousFocus;
    dialog.querySelectorAll('[data-csd-guided-dismiss]').forEach(function (button) {
      button.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var controls = dialog.querySelectorAll('a[href], button');
      var first = controls[0];
      var last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    });
    // Native Escape dismissal and both buttons share this one final state.
    dialog.addEventListener('close', function () {
      reminder.hidden = false;
      var target = previousFocus && previousFocus !== document.body && previousFocus.isConnected
        ? previousFocus : root.querySelector('[data-csd-side="front"]');
      if (target) target.focus({ preventScroll: true });
    });
    // Scheduled once, after the designer API is ready; never on a rerender.
    window.setTimeout(function () {
      if (!dialog.isConnected) return;
      previousFocus = document.activeElement;
      dialog.showModal();
    }, 1500);
  }

  initGuidedRecommendation();
}());
